import { FormSelect } from "components/primitives";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/esm/Form";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

interface DropdownOption {
  value: string;
  label: string;
}

interface DropdownInfo {
  name: string;
  options: (string | DropdownOption)[];
  defaultValue?: string;
}

export const DropdownSetting: WidgetSettingFC<any, DropdownInfo> = ({
  data,
  setData,
  info: { name, options, defaultValue },
}) => {
  const dropdownChanged = (value: string) => {
    setData(value);
  };

  useEffect(() => {
    if (defaultValue !== undefined) {
      setData(defaultValue);
    }
  }, [defaultValue]);

  return (
    <FormGroup>
      <FormLabel>{name}</FormLabel>
      <FormSelect onChange={(e: any) => dropdownChanged(e.target.value)} value={data}>
        {options.map((option, index) => {
          if (typeof option === "string") {
            return (
              <option key={index} value={option}>
                {option}
              </option>
            );
          } else {
            return (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            );
          }
        })}
      </FormSelect>
    </FormGroup>
  );
};

const FormGroup = styled(Form.Group)`
  margin-bottom: 35px;
`;

const FormLabel = styled(Form.Label)`
  color: var(--secondary);
  font-weight: 600;
  margin-bottom: 5px;
  font-size: 12pt;
`;
